import { render, staticRenderFns } from "./ClientTablePage.vue?vue&type=template&id=70101b59"
import script from "./ClientTablePage.vue?vue&type=script&lang=js"
export * from "./ClientTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports